import { computed } from 'vue'
import { useClientStore } from '@/stores/client'

/**
 * TEMPORARY: Per-client, per-section feature flags for hiding sections.
 * Remove this file when features are re-enabled for all clients.
 */
type HiddenSection = 'location' | 'serviceRole' | 'risk'

const CLIENT_HIDDEN_SECTIONS: Record<string, HiddenSection[]> = {
  // TEMPORARY: Friends and family workshop client.
  'Family & Friends': ['serviceRole', 'risk'],
  SIA: ['location', 'serviceRole', 'risk'],
  OAI: ['location', 'serviceRole', 'risk'],
}

/**
 * TEMPORARY: Check if a specific section is hidden for a given client.
 */
export function isClientSectionHidden(clientName: string | undefined, section: HiddenSection): boolean {
  return CLIENT_HIDDEN_SECTIONS[clientName ?? '']?.includes(section) ?? false
}

/**
 * TEMPORARY: Composable for client-based feature flags.
 */
export function useClientFeatureFlags() {
  const clientStore = useClientStore()

  const clientName = computed(() => clientStore.getUser?.name ?? '')

  const showLocationSection = computed(() => !isClientSectionHidden(clientName.value, 'location'))
  const showServiceRoleSection = computed(() => !isClientSectionHidden(clientName.value, 'serviceRole'))
  const showRiskSection = computed(() => !isClientSectionHidden(clientName.value, 'risk'))

  return {
    showLocationSection,
    showServiceRoleSection,
    showRiskSection,
  }
}
